/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/Report/ReportTable/Processing/Content"
  
}) {
let reportLastExecutionMessageValueData = fromData.useDataValue({ viewPath,
context: 'report',
path: 'last_execution.message',
})
let constantData = 'Processing...'
let aggregateData = fromAggregate.any(reportLastExecutionMessageValueData, constantData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXs}
 marginLeft={dtSpaceL}
 data="report.last_execution.message"
 data="'Processing...'"
 aggregate="/Simple/Data/aggregate.js any"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}